import { UncontrolledTooltip } from "reactstrap";
import { useUserPermissions } from "../../utils/hooks/useUserPermissions";

const IconButton = ({
  onClick,
  action,
  className,
  color,
  margin = 0,
  cursor = "pointer",
  title = "",
  tooltip = null,
  id = null,
}) => {
  const { canUpdate, canCreate } = useUserPermissions();

  const checkCanActions = () => {
    if (canCreate() && action === "C") return true;
    if (canUpdate() && action === "U") return true;
    return false;
  };

  /**
   action
   C = create
   U = update
   */

  return (
    <>
      {checkCanActions() && (
        <>
          <i
            title={title}
            className={className}
            style={{
              color,
              fontSize: 17,
              cursor,
              margin,
            }}
            onClick={onClick}
            id={id}
          />
          {tooltip && id && (
            <UncontrolledTooltip
              style={{ backgroundColor: "#6f42c1" }}
              placement="bottom"
              target={id}
            >
              {tooltip}
            </UncontrolledTooltip>
          )}
        </>
      )}
    </>
  );
};

export default IconButton;
